import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GetFieldValuePipe } from '@shared/core';
import { LocalizationPipe } from '@shared/modules/localization';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NzSelectModule, FormsModule, GetFieldValuePipe, LocalizationPipe],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: UISelect,
      multi: true,
    },
  ],
})
export class UISelect implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() value?: any;
  @Input() disabled?: boolean;
  @Input() size: 'large' | 'small' | 'default' = 'small';
  @Input() options?: any[];
  @Input() optionLabelField?: string;
  @Input() optionValueField?: string;

  private onChange: (_: any) => void = () => {
    // bruh. линтер не понимает, что это нужно. поэтому оставляем с брух
  };
  private onTouched: () => void = () => {
    // bruh. линтер не понимает, что это нужно. поэтому оставляем с брух
  };

  onValueChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
